import { useDispatch } from 'react-redux'

import Grid from '@mui/material/Grid'


import { AppDispatch } from 'redux/store'
import { setSubject, setGradeLevel, setDomain, trackActiveFilters } from 'redux/ui/goalbankUI'

import SelectField from 'components/atoms/fields/SelectField'

import formModel from 'utils/tableFilterModels/goalbankTableFilterModel'
import { gradeSelectData } from 'utils/helpers'
import { useGET_subjectsSelectQuery } from 'redux/api/subjectsApi'
import {  useGET_goalDomainsSelectQuery } from 'redux/api/goalbankApi'
import { useGET_setupOptionsQuery } from 'redux/api/setupApi'
import { FC } from 'react'

interface IProps {
  setupPrefix?: string,
}

const ExtraFiltersGoalbank: FC<IProps> = ({setupPrefix = ""}) => {
  const dispatch = useDispatch<AppDispatch>()

  const { data: setupData } = useGET_setupOptionsQuery(null, {skip: setupPrefix === ""})

  const { grade_level, subject, domain } = formModel()

  return (
    (setupPrefix === "" || setupData) &&  <>
      {(setupPrefix === "" || setupData.filter(sd => sd.slug == setupPrefix+"_subject" && sd.is_enabled).length == 1) 
        && <Grid item xs={2} xl={2}>
        <SelectField
            renderChildren={false}
            fieldProps={{ ...grade_level }}
            apiCall={gradeSelectData}
            onChange={(value: { id: any }) => {
              dispatch(setGradeLevel(value?.id ?? ''))
              dispatch(trackActiveFilters())
            }}
          />
      </Grid>}

      {(setupPrefix === "" || setupData.filter(sd => sd.slug == setupPrefix+"_grade" && sd.is_enabled).length == 1) 
       && <Grid item xs={4} xl={4}>
        <SelectField
          fieldProps={{ ...subject }}
          apiCall={useGET_subjectsSelectQuery}
          onChange={(value: { id: any }) => {
            dispatch(setSubject(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      }
      <Grid item xs={3} xl={3}>
        <SelectField
            fieldProps={{ ...domain }}
            apiCall={useGET_goalDomainsSelectQuery}
            onChange={(value: { id: any }) => {
              dispatch(setDomain(value?.id ?? ''))
              dispatch(trackActiveFilters())
            }}
          />
      </Grid>
    </>
  )
}
export default ExtraFiltersGoalbank